import { useEffect, useState, useRef } from 'react';

import { Model } from '@/explore/types';

import { Section } from '../common';
import { ModelExplorer } from './ModelExplorer';

import styles from './models.module.scss';

interface ModelsSectionProps {
  models: Model[];
}

export const ModelsSection = (props: ModelsSectionProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const updateDimensions = () => {
      const rect = container.getBoundingClientRect();
      setDimensions({
        width: rect.width,
        height: rect.height,
      });
    };

    // Initial measurement
    updateDimensions();

    // Use ResizeObserver to track container size changes
    const resizeObserver = new ResizeObserver(updateDimensions);
    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Section title="Data Models">
      <div className={styles.container}>
        <div ref={containerRef} className={styles.content}>
          {dimensions.width > 0 && dimensions.height > 0 && (
            <ModelExplorer
              models={props.models}
              width={dimensions.width}
              height={dimensions.height}
            />
          )}
        </div>
      </div>
    </Section>
  );
};
